import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changePassword } from '../../actions/firebase_actions';

class ChangePassword extends Component {

  constructor(props) {
      super(props);
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.state = {
        message: '',
    };
  }

    translateMessage(message) {
        console.log(message);
        switch (message) {
            case 'The email address is already in use by another account.':
                return 'Email je už zaregistrovaný';
            case 'Password should be at least 6 characters':
                return 'Heslo by malo obsahovať aspoň 6 znakov';
            case 'The email address is badly formatted.':
                return 'Zadaj správny email';
            case 'The password must be 6 characters long or more.':
                return "Heslo musí obsahovať aspoň 6 znakov.";
            case 'There is no user record corresponding to this identifier. The user may have been deleted.':
                return "Daná emailová adresa nie je registrovaná.";
            default:
                return message;
        }
    }

  onFormSubmit(event) {
      event.preventDefault();
      let password = this.refs.password.value;
      let repeatPassword = this.refs.repeatPassword.value;
      if (password !== repeatPassword) {
        this.setState({
          message: 'Heslo sa musí zhodovať!',
      });
    } else {
        this.props.changePassword(password).then((data) => {
          if (data.payload.errorCode)
            this.setState({ message: this.translateMessage(data.payload.errorMessage) });
          else
          this.setState({ message: 'Heslo bolo zmenené!' });
      });
    }
  }

    render() {
      return (
      <form id="ChangePassword" role="form" onSubmit={this.onFormSubmit}>
        <h4> Zmena Hesla </h4>
        <h5> {this.state.message} </h5>
        <div className="form-group">
          <label htmlFor="password"> Nové Heslo: </label>
          <input type="password" className="form-control"
            name="password" ref="password" id="password" 
          />
        </div>
        <div className="form-group">
          <label htmlFor="repeatPassword"> Znova Heslo: </label>
          <input type="password" className="form-control"
            name="repeatPassword" ref="repeatPassword" id="repeatPassword" 
          />

        </div>
        <button type="submit" className="btn btn-primary">Zmeniť Heslo</button>
      </form>
    );
  }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({ changePassword }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/app/components/user/change_password.jsx